module.exports = __webpack_public_path__ + "static/media/filter_icon_blue.5f1eeb9f.svg";